require('inputmask/dist/jquery.inputmask.js');
require('jquery-validation');
require('jquery-chained/jquery.chained');
import { Modal } from 'flowbite';

import { trapFocus } from './focus-trap';
// import Datepicker from 'flowbite-datepicker/Datepicker';

const modalToggle = document.getElementById('modal-book-tour');
const modal = new Modal(modalToggle);

var currentRequest = null;
const base_url = $('#base-url').attr('data-url');
var validator = null;
const urlParams = new URLSearchParams(window.location.search);
const urlPattern = /^\/properties\/[^\/]+\/?$/;
const isPropertyPage = urlPattern.test(window.location.pathname);

export const BookTourModal = {
    slots: [],
    resetFormCustom() {
        $('.book_tour_btn').show();
        $('.book-tour-form-submit__loader').addClass('hidden');
        $('.book-tour-form__message-toggle').removeClass('hidden');
        $('.book-tour-form__message').addClass('hidden');
        $('.book-tour-form__loader').addClass('hidden');
        $('.book-tour-form__form').removeClass('hidden');
        $('.tour24_link_div').addClass('hidden');
        $('.book-tour-response--success').addClass('hidden');
        $('.book-tour-response--error').addClass('hidden');

        $('#ApptDate').html(`<option value="">Select a date</option>`);
        $('#ApptTime').html(`<option value="">Select a time</option>`);

        $('select[name=TourType]').prop('selectedIndex', 0).val();
        $('input[name=FirstName]').val('');
        $('input[name=LastName]').val('');        
        $('input[name=Email]').val('');
        $('input[name=Phone]').val('');
        $('input[name=DesiredMoveinDate]').val('');
        $('select[name=DesiredBedrooms]').prop('selectedIndex', 0).val();
        $('textarea[name=Message]').val('');
        if ($('.datepicker')) {
            $('.datepicker .clear-btn').trigger('click');
        }
        $('#ApptDate').attr('disabled', 'disabled');
        $('#ApptTime').attr('disabled', 'disabled');
        validator?.resetForm();
        BookTourModal.messageToggler();
    },
    handleSuccess() {
        $('.book-tour-form__loader').addClass('hidden');
        $('.book-tour-form__form').addClass('hidden');
        $('.book-tour-response--error').addClass('hidden');
        $('.book-tour-response--success').removeClass('hidden');
    },
    handleError(error_message) {
        $('.book-tour-response--error').text(error_message);
        $('.book-tour-response--error').removeClass('hidden');
        $('.book-tour-response--success').addClass('hidden');
    },
    clearErrors() {
        $('.book-tour-response--error').addClass('hidden');
    },
    getDate(datetime) {
        var date_array = datetime.split(' ');
        return date_array[0];
    },
    getTime(datetime) {
        var date_array = datetime.split(' ');
        var time = date_array[1] + ' ' + date_array[2];
        var time_array = time.split(':');
        return time_array[0] + ':' + time_array[1] + ' ' + date_array[2];
    },
    populateForm() {
        $('.book_tour_btn').show();
        $('.book-tour-form-submit__loader').addClass('hidden');
        $('.book-tour-form__loader').addClass('hidden');
        $('.book-tour-form__form').removeClass('hidden');
        $('.book-tour-response--success').addClass('hidden');
        $('.book-tour-response--error').addClass('hidden');
        $('.tour24_link_div').addClass('hidden');

        var last_date = '';
        $('#ApptDate').html(`<option value="">Select a date</option>`);
        $('#ApptTime').html(`<option value="">Select a time</option>`);
        $('#ApptDate').removeAttr('disabled');
        $.each(BookTourModal.slots, function (i, slot) {
            var d = BookTourModal.getDate(slot.dtStart);
            var t = BookTourModal.getTime(slot.dtStart);
            if (last_date != d) {
                last_date = d;
                $('#ApptDate').append(`<option value="${d}">${d}</option>`);
            }
            $('#ApptTime').append(
                `<option value="${t}" data-chained="${d}">${t}</option>`
            );
        });

        BookTourModal.validate();

        $('#phoneNumber').inputmask('(999) 999-9999');

        $('#ApptTime').chained('#ApptDate');
    },
    messageToggler() {
        $('.book-tour-form__message-toggle').on('click', function () {
            $('.book-tour-form__message-toggle').addClass('hidden');
            $('.book-tour-form__message').removeClass('hidden');
            return false;
        });
    },
    validate: function () {
        $.validator.addMethod(
            'checkLengthTelNumber',
            function (value, element, param) {
                if ($(element).inputmask('unmaskedvalue').length === 10) {
                    return true;
                }
                return false;
            },
            'Please enter a valid number'
        );
        validator = $('.book-tour-form form').validate({
            rules: {
                ApptDate: 'required',
                ApptTime: 'required',
                TourType: 'required',
                FirstName: 'required',
                LastName: 'required',
                Email: {
                    required: true,
                    email: true,
                },
                Phone: {
                    required: true,
                    checkLengthTelNumber: true,
                },
                DesiredMoveinDate: 'required',
                DesiredBedrooms: 'required',
            },
            messages: {
                ApptDate: 'This field is required.',
                ApptTime: 'This field is required.',
                TourType: 'This field is required.',
                FirstName: 'This field is required.',
                LastName: 'This field is required.',
                Email: {
                    required: 'This field is required.',
                    email: 'The email address entered is invalid, please check the formatting (e.g. email@domain.com).',
                },
                Phone: 'This field is required.',
                DesiredMoveinDate: 'This field is required.',
                DesiredBedrooms: 'This field is required.',
            },
            submitHandler: function (form) {
                BookTourModal.clearErrors();
                var data_book_id = $('#modal-book-tour').attr('data-book-id');
                var group_id = $('.property_group_id_' + data_book_id).val();
                var form_type = $('.form_type_' + data_book_id).val();                
                var tour_type = $('[name=TourType]').val();
                var tour24_property_uuid = $('[name=tour24_property_uuid]').val();                
                $.ajax({
                    url: base_url + '/wp-admin/admin-ajax.php',
                    type: 'post',
                    dataType: 'json',
                    data: {
                        action: 'book_tour_submit',
                        body: {
                            ApptDate: $('[name=ApptDate]').val(),
                            ApptTime: $('[name=ApptTime]').val(),
                            TourType: $('[name=TourType]').val(),
                            FirstName: $('[name=FirstName]').val(),
                            LastName: $('[name=LastName]').val(),                            
                            Email: $('[name=Email]').val(),
                            Phone: $('[name=Phone]').inputmask('unmaskedvalue'),
                            DesiredMoveinDate: $(
                                '[name=DesiredMoveinDate]'
                            ).val(),
                            DesiredBedrooms: $('[name=DesiredBedrooms]').val(),
                            DesiredBedroomLayout: $('[name=DesiredBedrooms]').find('option:selected').attr('data-unitlayout'),
                            Message: $('[name=Message]').val(),
                            PropertyId: $('[name=PropertyId]').val(),
                            LeadSource: $('[name=LeadSource]').val(),
                            form_type: form_type,
                            group_id: group_id,
                            tour_type: tour_type,
                            property_post_id: data_book_id,                            
                            tour24_property_uuid:tour24_property_uuid
                        },
                        nonce: $('[name=nonce]').val(),
                    },
                    beforeSend: function () {
                        $('.book_tour_btn').hide();
                        $('.book-tour-form-submit__loader').removeClass(
                            'hidden'
                        );
                    },
                    success: function (response) {
                        var body = response.body;
                        var body_decoded = JSON.parse(body);
                        if (body_decoded.ErrorMessage.length > 0) {
                            BookTourModal.handleError(
                                body_decoded.ErrorMessage
                            );
                        } else {
                            if (tour_type == 1 && tour24_property_uuid != '') 
                                $(".book-tour-response--success").text("Thank you.  We’ll be contacting you shortly via text message and email to provide next steps in confirming your self-guided tour.");
                            else
                                $(".book-tour-response--success").text("Great news! Your tour has been successfully scheduled.");
                            BookTourModal.handleSuccess();
                        }
                        $('.book_tour_btn').show();
                        $('.book-tour-form-submit__loader').addClass('hidden');
                    },
                    error: function () {
                        BookTourModal.handleError(
                            'Booking tours is temporarily unavailable. Please try again later.'
                        );
                        $('.book_tour_btn').show();
                        $('.book-tour-form-submit__loader').addClass('hidden');
                    },
                });
                return false;
            },
        });
    },
    getDates() {
        $('.book_a_tour_btn').addClass('disabled');
        $('.book_tour_back').addClass('disabled');
        $('.self-guided-tour24-link').html('');
        var property_id = $('#modal-book-tour').attr('data-property-id');
        var data_book_id = $('#modal-book-tour').attr('data-book-id');
        var group_id = $('.property_group_id_' + data_book_id).val();
        var form_type = $('.form_type_' + data_book_id).val();
        var tour_type = $('[name=TourType]').val();     
        var self_guided_value = $('[name=TourType]').find('option[value="1"]').length > 0;   
        var tour24_property_uuid = $('[name=tour24_property_uuid]').val();        
           
            $('.tour24_link_div').addClass('hidden');
            // use ajax
            currentRequest = $.ajax({
                url: base_url + '/wp-admin/admin-ajax.php',
                type: 'post',
                data: {
                    action: 'book_tour_dates',
                    property_id: property_id,
                    form_type: form_type,
                    group_id: group_id,
                    tour_type: tour_type,                    
                    tour24_property_uuid:tour24_property_uuid
                },
                beforeSend: function () {
                    $('.book-tour-form__loader').removeClass('hidden');
                    $('.book-tour-form__form').addClass('hidden');
                    if (currentRequest != null) {
                        currentRequest.abort();
                    }
                },
                error: function () {
                    BookTourModal.handleError(
                        'Booking tours is temporarily unavailable. Please try again later.'
                    );
                    $('.book-tour-form__loader').addClass('hidden');
                    $('.book-tour-form__form').addClass('hidden');
                    $('.book_a_tour_btn').removeClass('disabled');
                    $('.book_tour_back').removeClass('disabled');     
                    if(self_guided_value){ 
                        if (tour_type != 1)
                            $('.self-guided-tour24-link').html(
                                "Preferred tour time not available? Click <a href='javascript:void(0)' class='prefered_time_sgt_call'>here</a> to schedule a self-guided tour!"
                            );
                        else $('.self-guided-tour24-link').html('');  
                    }            
                    setTimeout(() => {
                        trapFocus(document.getElementById('modal-book-tour'));
                    }, 100);
                },
                success: function (data) {
                    if (data) {
                        var results = JSON.parse(data);
                        BookTourModal.slots =
                            results.Response[0].AvailableSlots ||
                            results.Response[0].ThirdPartyAvailableSlots;

                        if (results.ErrorCode) {
                            BookTourModal.handleError(
                                'Booking tours is temporarily unavailable. Please try again later.'
                            );
                            $('.book-tour-form__loader').addClass('hidden');
                            $('.book-tour-form__form').addClass('hidden');
                        } else if (!BookTourModal.slots) {
                            BookTourModal.handleError(
                                'No timeslots located. Please try again later.'
                            );
                            $('.book-tour-form__loader').addClass('hidden');
                            $('.book-tour-form__form').addClass('hidden');
                        } else {
                            BookTourModal.populateForm();
                        }
                        if(results.Response[1] && results.Response[1].AvailableBedrooms){
                            $('select[name=DesiredBedrooms]').html('<option value="">Please select</option>');
                            $.each(results.Response[1].AvailableBedrooms, function (key, value) {
                                $('select[name=DesiredBedrooms]').append('<option value="'+value.id+'" data-unitLayout="'+value.layout+'">'+value.description+'</option>');
                            });
                                                           
                        }else{
                            BookTourModal.setBedRooms($('[data-book]'));                            
                        }
                    }
                    $('.book_a_tour_btn').removeClass('disabled');
                    $('.book_tour_back').removeClass('disabled');  
                    if(self_guided_value){   
                        if (tour_type != 1)
                            $('.self-guided-tour24-link').html(
                                "Preferred tour time not available? Click <a href='javascript:void(0)' class='prefered_time_sgt_call'>here</a> to schedule a self-guided tour!"
                            );
                        else $('.self-guided-tour24-link').html('');    
                    }           
                    setTimeout(() => {
                        trapFocus(document.getElementById('modal-book-tour'));
                    }, 100);
                },
            });
        //}
    },
    updateModalContent($book_trigger) {
        BookTourModal.resetFormCustom();

        var $modal = $('#modal-book-tour');
        var id = $book_trigger.attr('data-book-property-id');
        var title = $book_trigger.attr('data-book-title');
        var address = $book_trigger.attr('data-book-address');
        var citystate = $book_trigger.attr('data-book-citystate');
        var book_id = $book_trigger.attr('data-book-id');        
        var tour24_property_uuid = $book_trigger.attr('data-tour24-uuid');        
        BookTourModal.setBedRooms($book_trigger);
        $($modal).attr('data-property-id', id);
        $($modal).attr('data-book-id', book_id);
        $('.book-title', $modal).text(title);
        $('.book-address', $modal).text(address);
        $('.book-citystate', $modal).text(citystate);
        $('[name=PropertyId]').val(id);        
        $('[name=tour24_property_uuid]').val(tour24_property_uuid);        
        BookTourModal.getTourTypes(book_id);
    },
    setBedRooms($book_trigger){
        // Fetch Bedroom Count and Set in Desired Number of Bedrooms Form field
        var max_bedroom = $book_trigger.attr('data-book-max-beds');
        var min_bedroom = $book_trigger.attr('data-book-min-beds');
        $('.book-tour-form__desired-bedrooms')
            .find('option')
            .not(':first')
            .remove();
        if (min_bedroom == 0) {
            $('.book-tour-form__desired-bedrooms').append(
                '<option value="0">Studio</option>'
            );
        }
        if (max_bedroom > 0) {
            for (var n = 1; n <= max_bedroom; ++n) {
                $('.book-tour-form__desired-bedrooms').append(
                    '<option value="' + n + '">' + n + ' Bedroom</option>'
                );
            }
        }       
    },
    getTourTypes(property_id) {
        // use ajax
        $.ajax({
            url: base_url + '/wp-admin/admin-ajax.php',
            type: 'post',
            data: {
                action: 'book_tour_types',
                property_id: property_id,
            },

            error: function () {
                $('.book-tour-form-tour-type__loader').addClass('hidden');
                BookTourModal.handleError(
                    'No tour types available. Please try again later.'
                );
                trapFocus(document.getElementById('modal-book-tour'));
            },
            success: function (data) {
                if (data) {
                    var results = JSON.parse(data);
                    if (results != '') {
                        var _html = ''; //"<option value=''>Select a tour type</option>";
                        var _btn_html = '';
                        $.each(results, function (key, value) {
                            _html +=
                                "<option value='" +
                                value['value'] +
                                "'>" +
                                value['label'] +
                                '</option>';
                            if (key % 2 === 0) {
                                _btn_html +=
                                    '<div class="flex flex-col gap-4 md:flex-row">';
                            }
                            _btn_html +=
                                '<button class="flex flex-col border border-brand-primary p-4 select_tour_btn text-brand-primary hover:bg-brand-primary hover:text-white transition-all" data-val="' +
                                value['value'] +
                                '">' +
                                '<h2 class="font-semibold  mb-2 font-nunito-sans">' +
                                value['label'] +
                                '</h2>' +
                                '<p class=" text-left font-nunito-sans">' +
                                $(
                                    '#tour_type_' + value['value'] + '_desc'
                                ).val() +
                                '</p>' +
                                '</button>';
                            if (key % 2 !== 0) {
                                _btn_html += '</div>';
                            }
                        });
                        if (results.length % 2 !== 0) {
                            _btn_html += '</div>';
                        }
                        $('select[name=TourType]').html(_html);
                        $('.tour_type_list').html(_btn_html);
                        var for_sgt_tour = $("#for-sgt-page").val();                        
                        if(typeof for_sgt_tour !== "undefined" && for_sgt_tour == '1'){                                                    
                            $('.select_tour_btn[data-val="1"]').trigger("click");                            
                        }
                    } else {
                        BookTourModal.handleError(
                            'No tour types available. Please try again later.'
                        );
                    }
                } else {
                    BookTourModal.handleError(
                        'No tour types available. Please try again later.'
                    );
                }
                $('.book-tour-form-tour-type__loader').addClass('hidden');
                trapFocus(document.getElementById('modal-book-tour'));
            },
        });
    },
    checkURLForModal() {
        if (urlParams.has('scheduleTourModal')) {
            BookTourModal.modalContent();
            BookTourModal.updateModalContent($('.cta-book-tour [data-book]'));
        }
    },
    modalContent() {
        $('.tour_type_list').html('');
        $('.book-tour-form-tour-type__loader').removeClass('hidden');
        $('.book_tour_first_section').removeClass('hidden');
        $('.book_tour_second_section').addClass('hidden');
        
        modal.show();
        trapFocus(document.getElementById('modal-book-tour'));
    },
    init() {
        let previousElement = null;

        $(document).on('click', '[data-book]', function () {
            BookTourModal.modalContent();
            BookTourModal.updateModalContent($(this));
            if ($('body').hasClass('single-windsor_properties')) {
                if ($('.spaces__tab-container').length > 0) {
                    previousElement = $('.spaces__tab-container');
                } else {
                    previousElement = $(this);
                }
           } else {
                previousElement = $(this);
            }

             return false;
        });

        const datepickerEl = document.querySelector(
            '.book-tour-form__form .book-date'
        );

        if (datepickerEl !== null) {
            datepickerEl.setAttribute('readonly', true);
            new Datepicker(datepickerEl, {
                autohide: true,
                minDate: new Date(),
            });
        }

        $(document).on('change', 'select[name=TourType]', function () {                         
            BookTourModal.getDates();           
        });

        // When click on the here link of the verbiage
        $(document).on('click', '.prefered_time_sgt_call', function () {                         
            $('select[name=TourType]').val(1);            
            BookTourModal.getDates();      
        });
        
        $(document).on('change', '#ApptDate', function () {            
            var tour24_property_uuid = $('[name=tour24_property_uuid]').val();            
            var tourType = $('select[name=TourType]').val();
            var date = $(this).val();
            if (tourType == 1 && tour24_property_uuid != '') {
                $.ajax({
                    url: base_url + '/wp-admin/admin-ajax.php',
                    type: 'post',
                    data: {
                        action: 'get_tour24_times',
                        date: date,
                        tour24_property_uuid: tour24_property_uuid
                    },
                    beforeSend: function () {
                        $('.book_tour_btn').hide();
                        $('.book-tour-form-submit__loader').removeClass(
                            'hidden'
                        );
                        $('#ApptTime').attr('disabled', 'disabled');
                    },
                    error: function () {
                        $('.book_tour_btn').show();
                        $('.book-tour-form-submit__loader').addClass('hidden');  
                        $('#ApptTime').removeAttr('disabled');
                    },
                    success: function (data) {
                        var results = JSON.parse(data);
                        $('#ApptTime').html(`<option value="">Select a time</option>`);
                        $.each(results, function (i, slot) { 
                            if(!slot.isTourNow){  
                                var time_data = JSON.stringify(slot);                         
                                var dateTimeString = slot.startDateTime;  
                            
                                // Convert to a Date object
                                const dateval = new Date(dateTimeString);

                                // Extract hours and minutes
                                let hours = dateval.getHours();
                                const minutes = dateval.getMinutes();
                                const ampm = hours >= 12 ? "PM" : "AM";

                                // Convert hours to 12-hour format
                                hours = hours % 12 || 12; // Adjust for 12-hour clock
                                const formattedMinutes = minutes.toString().padStart(2, "0"); // Ensure 2-digit minutes

                                // Combine time with AM/PM
                                const formattedTime = `${hours}:${formattedMinutes} ${ampm}`;                          
                                $('#ApptTime').append(
                                    `<option value='${time_data}' data-chained="${date}">${formattedTime}</option>`
                                );
                            }
                        });
                        $('.book_tour_btn').show();
                        $('.book-tour-form-submit__loader').addClass('hidden');  
                        $('#ApptTime').removeAttr('disabled');
                    },
                });
            }
        });

        $(document).on('click', '.select_tour_btn', function () {
            var dataVal = $(this).attr('data-val');
            $('select[name=TourType]').val(dataVal);
            //$('select[name=TourType]').trigger("change");
            BookTourModal.getDates();
            $('.book_tour_first_section').addClass('hidden');
            $('.book_tour_second_section').removeClass('hidden');
            setTimeout(() => {
                trapFocus(document.getElementById('modal-book-tour'));
            }, 200);
        });

        $(document).on('click', '.book_tour_back', function () {
            $('.book_tour_first_section').removeClass('hidden');
            $('.book_tour_second_section').addClass('hidden');
        });

        // set focus on modal close button click
        $(document).on(
            'click',
            '#modal-book-tour .wc_modal_close',
            function (event) {
                window.setTimeout(() => {
                    // $('body,.page-content').removeClass('hide-overflow fixed');
                    previousElement?.focus();
                    // $('body').css('padding-right', '0px');
                    // toggleModal('modal-book-tour', false);
                    modal.hide();
                }, 100);
            }
        );

        document.addEventListener('DOMContentLoaded', function () {
            Flowbite.init();
        });

        $(document).keyup(function (e) {
            if (e.key === 'Escape') {
                if (
                    $('#modal-book-tour').length > 0 &&
                    $('#modal-book-tour').is(':visible')
                ) {  
                    modal.hide();
                }
            }
        });

        if (isPropertyPage) {
            BookTourModal.checkURLForModal();
        }
        
    },
};
